import actions from "@/store/modules/order-part/actions";
import mutations from "@/store/modules/order-part/mutations";
import state from "@/store/modules/order-part/state";

export default {
    actions,
    mutations,
    state
}
